import { NavParams } from 'ionic-angular/navigation/nav-params';
import { LicenseManagerService } from './../../shared/licensemanager-service/licensemanager.service';
import { Component, OnInit, Input } from '@angular/core';
import { ToastController, Alert, AlertController } from 'ionic-angular';
import { SPHLoggedInUser } from '../../shared/shared';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Component({
    selector: 'lm-company-license-settings',
    templateUrl: 'company-license-settings.component.html'
})

export class CompanyLicenseSettingsComponent {
    private _user: SPHLoggedInUser;
    @Input() set user(user: SPHLoggedInUser) {
        this._user = user;

        if (user !== undefined && user != null) {
            this.licenseManagerService.getSublementaryLicenseInformation(user.jwt).subscribe((response) => {
                this.preText = response.pre_license_text;
                this.postText = response.post_license_text;

                this.eMailPretext = response.pre_email_text;
                this.eMailPosttext = response.post_email_text;
            }, this.licenseManagerService.handleHttpError('Fehler beim Holen der Informationen'));

            this.licenseManagerService.getSMTPCredentials(user.jwt).subscribe((credentials) => {
                this.smtpCredentials = credentials;
                // this.host = credentials.host;
                // this.port = credentials.port;
                // this.secure = credentials.secure;
                // this.smtpusername = credentials.user;
                // this.smtppassword = credentials.pass;
            }, this.licenseManagerService.handleHttpError('Fehler beim Holen der SMTP Informationen'));
        }
    }
    get user(): SPHLoggedInUser {
        return this._user;
    }

    private preText: string;
    private postText: string;

    private eMailPretext: string;
    private eMailPosttext: string;

    private smtpCredentials: { host: string, port: number, secure: boolean, user: string, pass: string };

    constructor(private navParams: NavParams, private licenseManagerService: LicenseManagerService, private toastController: ToastController, private alertController: AlertController) {
        this.user = navParams.get('user');
    }

    public didTapSendSublementaryLicenseInformation() {
        this.licenseManagerService.setSublementaryLicenseInformation(this.preText, this.postText, this.eMailPretext, this.eMailPosttext, this.user.jwt).subscribe((response) => {
            const toast = this.toastController.create({ message: 'Informationen gesendet.', duration: 3000 });
            toast.present();
        }, this.licenseManagerService.handleHttpError('Fehler beim Speichern der Informationen.'));
    }

    public shouldSaveSMTPData(data: { host: string, port: number, secure: boolean, user: string, pass: string }) {
        // save...
        this.licenseManagerService.setSMTPCredentials(data.host, data.port, data.secure, data.user, data.pass, this.user.jwt).subscribe((response) => {
            const toast = this.toastController.create({ message: 'Testmail gesendet. SMTP-Credentials gesetzt.', duration: 3000 });
            toast.present();
        }, this.handleErrorSMTPInformation());
    }

    public shouldResetSMTPData(event) {
        // TODO actually reset data
        const smtp = this.smtpCredentials;
        this.smtpCredentials = undefined;
        this.smtpCredentials = smtp;

        this.licenseManagerService.deleteSMTPCredentials(this.user.jwt).subscribe((response) => {
            const toast = this.toastController.create({ message: 'SMTP-Einstellungen zurückgesetzt.', duration: 3000 });
            toast.present();
        }, this.licenseManagerService.handleHttpError('Fehler beim zurücksetzen der Informationen.'));
    }

    // didTapSendSMTPInformation() {
    //     this.licenseManagerService.setSMTPCredentials(this.host, this.port, this.secure, this.smtpusername, this.smtppassword, this.user.jwt).subscribe((response) => {
    //         let toast = this.toastController.create({ message: 'Testmail gesendet. SMTP-Credentials gesetzt.', duration: 3000 });
    //         toast.present();
    //     }, this.handleErrorSMTPInformation())
    // }

    // didTapResetSMTPInformation() {
    //     this.licenseManagerService.deleteSMTPCredentials(this.user.jwt).subscribe((response) => {
    //         let toast = this.toastController.create({ message: 'SMTP-Einstellungen zurückgesetzt.', duration: 3000 });
    //         toast.present();
    //     }, this.licenseManagerService.handleHttpError('Fehler beim zurücksetzen der Informationen.'))
    // }

    public handleErrorSMTPInformation<T>() {
        return (error: HttpErrorResponse): Observable<T> => {
            if (error.status === 502) {
                const alert = this.alertController.create({
                    title: 'SMTP Informationen ungültig',
                    message: 'Mit den hinterlegten SMTP-Informationen konnte die Testmail nicht erfolgreich versendet werden. Die Einstellungen wurden wieder auf die RealCore-Standardwerte zurückgesetzt. Bitte überprüfen Sie Ihre Eingaben und Speichern Sie diese erneut.',
                    buttons: [
                        {
                            text: 'OK',
                            role: 'cancel',
                        },
                    ]
                });
                alert.present();
                throw error;
            }

            return this.licenseManagerService.handleHttpError<T>('Fehler beim Speichern der Informationen.')(error);
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/companyLicenseSettingsComponent/company-license-settings.component.ts